import Sketchfab from '../../../manual_modules/sketchfab-viewer-1.5.1'

let client, api

const init = function (elementId) {
  var iframe, version
  iframe = document.getElementById(elementId)
  version = '1.5.1'
  client = new Sketchfab(version, iframe)
}

const loadScene = function (sceneId, scope, viewerReadyCallback, playerSettings, clickEvent) {
  client.init(sceneId, {
    success: function onSuccess (theApi) {
      console.log('Client success')
      window.api = api = theApi
      api.load()
      api.start()
      api.addEventListener('viewerready', function () {
        console.log('Viewer ready')

        if (viewerReadyCallback) {
          // need to pass through the scope of the vue component this callback is in.
          // couldn't make it work with .this otherwise
          viewerReadyCallback(scope)
        }
      })
      api.addEventListener('click', function (info) {
        if (clickEvent) {
          clickEvent(info)
        }
      }, { pick: 'fast' })
    },
    error: function (error) {
      console.log(error)
    },
    autospin: 0.0,
    preload: 0,
    transparent: 0,
    camera: 1, // skips the entry animation, we have more control by setting the viewer position manually
    //  blending: 0,
    ui_stop: 0,
    ui_infos: 0, // need biz account
    ui_controls: 0, // need biz account
    ui_watermark: 0,
    scrollwheel: 1,
    graph_optimizer: 0,
    merge_materials: 0,
    orbit_constraint_pitch_down: playerSettings.orbit_constraint_pitch_down,
    orbit_constraint_pitch_up: playerSettings.orbit_constraint_pitch_up,
    orbit_constraint_yaw_left: playerSettings.orbit_constraint_yaw_left,
    orbit_constraint_yaw_right: playerSettings.orbit_constraint_yaw_right,
    orbit_constraint_zoom_in: playerSettings.orbit_constraint_zoom_in,
    orbit_constraint_zoom_out: playerSettings.orbit_constraint_zoom_out,
    orbit_constraint_pan: playerSettings.orbit_constraint_pan
  })
}

const getApi = function () {
  return api
}

export default {getApi, init, loadScene}
